import React from "react";
import {css} from "@panda/css";

import {MULTILEAD_RESPONSIVE_MODAL_TEST_IDS} from "@pg-mono/test-ids";

import {OSMGenericNearbyOffersMap} from "../../../maps/components/generic_nearby_offers/open_street_maps/OSMGenericNearbyOffers";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {
    MULTI_LEAD_PROPERTY_PIN,
    MULTI_LEAD_SELECTED_PROPERTY_PIN,
    MULTI_LEAD_VIEWED_OFFER_DOT
} from "../../constants/multi_lead/application_multi_lead_map_pins";
import {transformRecommendedPropertyIntoMapOffer} from "../../utils/multi_lead/application_multi_lead_transform_to_map_offer";

const VIEWED_OFFER_RADIUS_GRADIENT_ID = "multi-lead-viewed-offer-radius-gradient";
const PROPERTY_PIN_SIZES: [number, number] = [30, 38];
const VIEWED_OFFER_DOT_SIZES: [number, number] = [26, 26];
const VIEWED_OFFER_RADIUS_PATH_OPTIONS = {
    stroke: false,
    fillColor: `url(#${VIEWED_OFFER_RADIUS_GRADIENT_ID})`,
    fillOpacity: 0.4
};

interface IProps {
    checkedList: number[];
    viewType: ViewType | null;
    originalGeoPoint: {
        coordinates: [number, number];
    };
    originalCountry: Country;
    recommendations: IRecommendedProperty[];
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    hoveredItemID: number | null;
    mainPropertyId?: number;
}

const getNoMarkerLabel = () => "";

const ApplicationMultiLeadResponsiveModalMapC = (props: IProps) => {
    const {checkedList, viewType, originalGeoPoint, originalCountry, recommendations, handlePinClick, hoveredItemID, mainPropertyId} = props;

    const getMarkerIcon = (propertyId: number): string => (checkedList.includes(propertyId) ? MULTI_LEAD_SELECTED_PROPERTY_PIN : MULTI_LEAD_PROPERTY_PIN);

    const handleDesktopInfoWindowOpen = (recommendedItemID: number) => {
        handlePinClick(viewType, recommendedItemID);
    };

    const handleOriginalMarkerClick = mainPropertyId ? () => handlePinClick(viewType, mainPropertyId) : undefined;

    return (
        <div className={mapWrapperStyle} data-testid={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.MAP}>
            <svg width="0" height="0" aria-hidden="true" focusable="false" className={gradientDefinitionsStyle}>
                <defs>
                    <radialGradient id={VIEWED_OFFER_RADIUS_GRADIENT_ID}>
                        <stop offset="0" className={gradientStopStyle} />
                        <stop offset="1" stopOpacity="0.35" className={gradientStopStyle} />
                    </radialGradient>
                </defs>
            </svg>

            <OSMGenericNearbyOffersMap
                drawCircleAroundMarkers
                circlePathOptions={VIEWED_OFFER_RADIUS_PATH_OPTIONS}
                viewType={viewType}
                hoveredItemID={hoveredItemID}
                originalMarkerCoordinates={originalGeoPoint.coordinates}
                offers={recommendations.map(transformRecommendedPropertyIntoMapOffer)}
                getMarkerIcon={getMarkerIcon}
                getMarkerLabel={getNoMarkerLabel}
                markerIconSizes={PROPERTY_PIN_SIZES}
                originalMarkerIcon={MULTI_LEAD_VIEWED_OFFER_DOT}
                originalMarkerIconSizes={VIEWED_OFFER_DOT_SIZES}
                originalMarkerCountry={originalCountry}
                onDesktopInfoWindowOpen={handleDesktopInfoWindowOpen}
                onOriginalMarkerClick={handleOriginalMarkerClick}
            />
        </div>
    );
};

export const ApplicationMultiLeadResponsiveModalMap = React.memo(ApplicationMultiLeadResponsiveModalMapC);

const mapWrapperStyle = css({
    position: "relative",
    isolation: "isolate",
    width: "100%",
    height: "33.8rem",
    md: {
        height: "100%"
    }
});

const gradientDefinitionsStyle = css({
    position: "absolute",
    width: 0,
    height: 0,
    overflow: "hidden"
});

const gradientStopStyle = css({
    stopColor: "var(--colors-primary)"
});
import React from "react";
import {css} from "@panda/css";

import {MULTILEAD_RESPONSIVE_MODAL_TEST_IDS} from "@pg-mono/test-ids";

import {OSMGenericNearbyOffersMap} from "../../../maps/components/generic_nearby_offers/open_street_maps/OSMGenericNearbyOffers";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {
    MULTI_LEAD_PROPERTY_PIN,
    MULTI_LEAD_SELECTED_PROPERTY_PIN,
    MULTI_LEAD_VIEWED_OFFER_DOT
} from "../../constants/multi_lead/application_multi_lead_map_pins";
import {transformRecommendedPropertyIntoMapOffer} from "../../utils/multi_lead/application_multi_lead_transform_to_map_offer";

const VIEWED_OFFER_RADIUS_GRADIENT_ID = "multi-lead-viewed-offer-radius-gradient";
const PROPERTY_PIN_SIZES: [number, number] = [30, 38];
const VIEWED_OFFER_DOT_SIZES: [number, number] = [26, 26];
const VIEWED_OFFER_RADIUS_PATH_OPTIONS = {
    stroke: false,
    fillColor: `url(#${VIEWED_OFFER_RADIUS_GRADIENT_ID})`,
    fillOpacity: 0.4
};

interface IProps {
    checkedList: number[];
    viewType: ViewType | null;
    originalGeoPoint: {
        coordinates: [number, number];
    };
    originalCountry: Country;
    recommendations: IRecommendedProperty[];
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    hoveredItemID: number | null;
    mainPropertyId?: number;
}

const getNoMarkerLabel = () => "";

const ApplicationMultiLeadResponsiveModalMapC = (props: IProps) => {
    const {checkedList, viewType, originalGeoPoint, originalCountry, recommendations, handlePinClick, hoveredItemID, mainPropertyId} = props;

    const getMarkerIcon = (propertyId: number): string => (checkedList.includes(propertyId) ? MULTI_LEAD_SELECTED_PROPERTY_PIN : MULTI_LEAD_PROPERTY_PIN);

    const handleDesktopInfoWindowOpen = (recommendedItemID: number) => {
        handlePinClick(viewType, recommendedItemID);
    };

    const handleOriginalMarkerClick = mainPropertyId ? () => handlePinClick(viewType, mainPropertyId) : undefined;

    return (
        <div className={mapWrapperStyle} data-testid={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.MAP}>
            <svg width="0" height="0" aria-hidden="true" focusable="false" className={gradientDefinitionsStyle}>
                <defs>
                    <radialGradient id={VIEWED_OFFER_RADIUS_GRADIENT_ID}>
                        <stop offset="0" className={gradientStopStyle} />
                        <stop offset="1" stopOpacity="0.35" className={gradientStopStyle} />
                    </radialGradient>
                </defs>
            </svg>

            <OSMGenericNearbyOffersMap
                drawCircleAroundMarkers
                circlePathOptions={VIEWED_OFFER_RADIUS_PATH_OPTIONS}
                viewType={viewType}
                hoveredItemID={hoveredItemID}
                originalMarkerCoordinates={originalGeoPoint.coordinates}
                offers={recommendations.map(transformRecommendedPropertyIntoMapOffer)}
                getMarkerIcon={getMarkerIcon}
                getMarkerLabel={getNoMarkerLabel}
                markerIconSizes={PROPERTY_PIN_SIZES}
                originalMarkerIcon={MULTI_LEAD_VIEWED_OFFER_DOT}
                originalMarkerIconSizes={VIEWED_OFFER_DOT_SIZES}
                originalMarkerCountry={originalCountry}
                onDesktopInfoWindowOpen={handleDesktopInfoWindowOpen}
                onOriginalMarkerClick={handleOriginalMarkerClick}
            />
        </div>
    );
};

export const ApplicationMultiLeadResponsiveModalMap = React.memo(ApplicationMultiLeadResponsiveModalMapC);

const mapWrapperStyle = css({
    position: "relative",
    isolation: "isolate",
    width: "100%",
    height: "33.8rem",
    md: {
        height: "100%"
    }
});

const gradientDefinitionsStyle = css({
    position: "absolute",
    width: 0,
    height: 0,
    overflow: "hidden"
});

const gradientStopStyle = css({
    stopColor: "var(--colors-primary)"
});
